import { hasKey, hasKeyWithType } from '@pn/core/utils/logic';
import { isArray, isObject, isString } from 'lodash-es';

export function isGeoJSONGeometry(arg: unknown): arg is GeoJSON.Geometry {
  return (
    isObject(arg) &&
    hasKeyWithType(arg, 'type', isString) &&
    [
      'Point',
      'MultiPoint',
      'LineString',
      'MultiLineString',
      'Polygon',
      'MultiPolygon',
      /* GeometryCollection isn't supported. */
    ].includes(arg.type) &&
    hasKeyWithType(arg, 'coordinates', isArray)
  );
}

export function isGeoJSONFeatureCollection(
  arg: unknown
): arg is GeoJSON.FeatureCollection {
  return (
    isObject(arg) &&
    hasKey(arg, 'type') &&
    arg.type === 'FeatureCollection' &&
    hasKeyWithType(arg, 'features', isArray)
  );
}

export function isPolygonLike(
  geometry: GeoJSON.Geometry
): geometry is GeoJSON.Polygon | GeoJSON.MultiPolygon {
  return geometry.type === 'Polygon' || geometry.type === 'MultiPolygon';
}
